export class MedianDetector {
  constructor(count, meanPointCount) {
    this.valueCount = count;
    this.currValueCount = 0;
    this.sourceValues = Array.from({ length: this.valueCount }, () => 0);
    this.sortedValues = Array.from({ length: this.valueCount }, () => 0);
    this.median = 0;
    this.medianIndex = count * 0.5;
    this.meanPointCount = meanPointCount;
    this.lastValueIndex = count - 1;
    this.insertSourceIndex = 0;
  }

  hasFullData() {
    return this.currValueCount > this.meanPointCount;
  }

  getMedian() {
    return this.median;
  }

  getCount() {
    return this.currValueCount;
  }

  clear() {
    this.median = 0;
    this.currValueCount = 0;
    this.insertSourceIndex = 0;
  }

  addValue(newValue) {
    if (this.currValueCount < this.valueCount) {
      this.sourceValues[this.currValueCount] = newValue;
      this.sortNotFullArray(newValue);
      this.calcMedianByNotFullArray();
      this.currValueCount++;
    } else {
      if (this.insertSourceIndex == this.valueCount) {
        this.insertSourceIndex = 0;
      }
      let deletedValue = this.sourceValues[this.insertSourceIndex];
      this.sourceValues[this.insertSourceIndex] = newValue;
      this.sortFullArray(newValue, deletedValue);
      this.calcMedianByFullArray();
      this.insertSourceIndex++;
    }
  }

  // private:
  calcMedianByNotFullArray() {
    let meanIndex = (this.currValueCount + 1) * 0.5;
    let lowBorderIndex = meanIndex - this.meanPointCount;
    if (lowBorderIndex < 0) {
      lowBorderIndex = 0;
    }
    let upBorderIndex = meanIndex + this.meanPointCount;
    if (upBorderIndex > this.currValueCount) {
      upBorderIndex = this.currValueCount;
    }
    let sumValue = 0;
    for (let i = lowBorderIndex; i <= upBorderIndex; i++) {
      sumValue += this.sortedValues[i];
    }
    this.median = sumValue / (upBorderIndex - lowBorderIndex + 1);
  }

  calcMedianByFullArray() {
    let lowBorderIndex = this.medianIndex - this.meanPointCount;
    if (lowBorderIndex < 0) {
      lowBorderIndex = 0;
    }
    let upBorderIndex = this.medianIndex + this.meanPointCount;
    if (upBorderIndex >= this.valueCount) {
      upBorderIndex = this.lastValueIndex;
    }
    let sumValue = 0;
    for (let i = lowBorderIndex; i <= upBorderIndex; i++) {
      sumValue += this.sortedValues[i];
    }
    this.median = sumValue / (upBorderIndex - lowBorderIndex + 1);
  }

  sortNotFullArray(newValue) {
    this.sortedValues[this.currValueCount] = newValue;
    let insertedIndex = this.currValueCount - 1;
    for (; insertedIndex >= 0 && this.sortedValues[insertedIndex] > newValue; insertedIndex--) {
      this.sortedValues[insertedIndex + 1] = this.sortedValues[insertedIndex];
      this.sortedValues[insertedIndex] = newValue;
    }
  }

  sortFullArray(newValue, deletedValue) {
    if (newValue == deletedValue) {
      return;
    }
    let insertIndex = 0;
    if (newValue > deletedValue) {
      // move items to left
      insertIndex = this.searchLeftMoveIndex(newValue, 0, this.sortedValues.length - 1);
      let deleteIndex = insertIndex;
      if (this.sortedValues[insertIndex] != deletedValue) {
        deleteIndex = this.searchLeftMoveIndex(deletedValue, 0, insertIndex - 1);
      }
      for (let i = deleteIndex + 1; i <= insertIndex; i++) {
        this.sortedValues[i - 1] = this.sortedValues[i];
      }
    } else {
      // move items to right
      insertIndex = this.searchRightMoveIndex(newValue, 0, this.lastValueIndex);
      let deleteIndex = insertIndex;
      if (this.sortedValues[insertIndex] != deletedValue) {
        deleteIndex = this.searchRightMoveIndex(deletedValue, insertIndex + 1, this.lastValueIndex);
      }
      for (let i = deleteIndex - 1; i >= insertIndex; i--) {
        this.sortedValues[i + 1] = this.sortedValues[i];
      }
    }
    this.sortedValues[insertIndex] = newValue;
  }

  searchLeftMoveIndex(searchValue, lowBorderIndex, upBorderIndex) {
    let isSearch = true;
    while (isSearch) {
      if (lowBorderIndex == upBorderIndex - 1) {
        if (this.sortedValues[upBorderIndex] <= searchValue) {
          return upBorderIndex;
        } else if (this.sortedValues[lowBorderIndex] <= searchValue) {
          return lowBorderIndex;
        } else {
          return lowBorderIndex - 1; // leftMove гарантирует что слева есть еще эл-ты
        }
      } else if (lowBorderIndex == upBorderIndex) {
        if (this.sortedValues[lowBorderIndex] <= searchValue) {
          return lowBorderIndex;
        } else {
          return lowBorderIndex - 1; // leftMove гарантирует что слева есть еще эл-ты
        }
      } else {
        let meanIndex = Math.trunc((upBorderIndex + lowBorderIndex) * 0.5); // get int value
        if (this.sortedValues[meanIndex] == searchValue) {
          return meanIndex;
        } else if (this.sortedValues[meanIndex] > searchValue) {
          upBorderIndex = meanIndex;
        } else {
          lowBorderIndex = meanIndex;
        }
      }
    }
  }

  searchRightMoveIndex(searchValue, lowBorderIndex, upBorderIndex) {
    let isSearch = true;
    while (isSearch) {
      if (lowBorderIndex == upBorderIndex - 1) {
        if (this.sortedValues[lowBorderIndex] >= searchValue) {
          return lowBorderIndex;
        } else if (this.sortedValues[upBorderIndex] >= searchValue) {
          return upBorderIndex;
        } else {
          return upBorderIndex + 1; // rightMove гарантирует что справа есть еще эл-ты
        }
      } else if (lowBorderIndex == upBorderIndex) {
        if (this.sortedValues[lowBorderIndex] >= searchValue) {
          return lowBorderIndex;
        } else {
          return lowBorderIndex + 1; // rightMove гарантирует что справа есть еще эл-ты
        }
      } else {
        let meanIndex = Math.trunc((upBorderIndex + lowBorderIndex) * 0.5); // get int value
        if (this.sortedValues[meanIndex] == searchValue) {
          return meanIndex;
        } else if (this.sortedValues[meanIndex] > searchValue) {
          upBorderIndex = meanIndex;
        } else {
          lowBorderIndex = meanIndex;
        }
      }
    }
  }
}
